import type { FirebaseRepository } from './FirebaseRepository'

export class FirebaseRepositoryUtils {
  constructor(public repository: FirebaseRepository) {}

  get searcher() {
    return new Intl.Collator(this.repository.locale, {
      usage: 'search',
      sensitivity: 'base',
    })
  }

  searchString(target: string, search: string) {
    return normalizedSearch(target, search, this.searcher)
  }

  sorter() {
    return new Intl.Collator(this.repository.locale, {
      usage: 'sort',
      numeric: true,
    })
  }

  compareStrings(a: string, b: string) {
    return this.sorter().compare(a, b)
  }
}

// This performs a search in a way that should be more forgiving:
// 1. Differences in unicode that wouldn't show visually but would fail
//    a.indexOf(b)
// 2. Makes similar characters equivalent (e.g. "o" and "ø") (so you can search
//    for "o" and get "Søren")
// 3. Follows any localization rules of the current language that would make
//    searching easier (eg "oo" in English is equivalent to "ö" in German) (note
//    that we get this via the passed in collator)
function normalizedSearch(
  target: string,
  search: string,
  collator: Intl.Collator
) {
  const canonicalTarget = target.normalize('NFC')
  const canonicalSearch = search.normalize('NFC')
  let found = false
  for (let i = 0; canonicalSearch.length + i <= canonicalTarget.length; i++) {
    const slice = canonicalTarget.slice(i, canonicalSearch.length + i)
    if (collator.compare(slice, canonicalSearch) === 0) {
      found = true
      break
    }
  }
  return found
}
